"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentErrorProfileSchema = exports.ProfileDispatchSchema = exports.ProfileSampleSchema = exports.ProfileSampleRunSchema = exports.ProfileErrorCodeBucketSchema = exports.ProfileClauseBucketSchema = exports.ProfileOccurrenceSchema = exports.ProfileCitedClauseSchema = exports.ProfileDictionarySchema = exports.ProfileErrorCodeEntrySchema = exports.ProfileClauseEntrySchema = exports.ProfileCurrentClauseSchema = exports.ProfileStatusSchema = exports.ProfileTotalsSchema = exports.ProfileExperimentRefSchema = exports.ProfiledDisagreementSchema = exports.DisagreementClassificationSchema = exports.SampleRefSchema = exports.DisagreementResolutionSchema = exports.DisagreementResolution = exports.EXPERIMENT_ERROR_PROFILE_VERSION = void 0;
const z = require("zod");
const consensus_types_1 = require("../Consensus/consensus.types");
const property_key_1 = require("../Consensus/property-key");
const slice_key_1 = require("../Consensus/slice-key");
const package_data_spec_status_1 = require("../PackageDataSpec/package-data-spec-status");
const plan_status_1 = require("../Wizard/plan-status");
const package_data_adjudication_types_1 = require("./package-data-adjudication.types");
exports.EXPERIMENT_ERROR_PROFILE_VERSION = 4;
var DisagreementResolution;
(function (DisagreementResolution) {
    DisagreementResolution["Error"] = "error";
    DisagreementResolution["NotAnError"] = "not_an_error";
    DisagreementResolution["AwaitingExpert"] = "awaiting_expert";
    DisagreementResolution["NotDispatched"] = "not_dispatched";
    DisagreementResolution["Structural"] = "structural";
})(DisagreementResolution || (exports.DisagreementResolution = DisagreementResolution = {}));
exports.DisagreementResolutionSchema = z.nativeEnum(DisagreementResolution);
exports.SampleRefSchema = z.object({
    sampleResultId: z.string(),
    packageId: z.string(),
    runNumber: z.number().int(),
    mpn: z.string(),
    packageUrl: z.string(),
});
exports.DisagreementClassificationSchema = z.object({
    clauses: package_data_adjudication_types_1.ClauseCitationSchema.array(),
    errorCodeIds: z.string().array(),
    comment: z.string().nullable(),
    statementId: z.string(),
    adjudicatedByUserId: z.string(),
    adjudicatedByUserName: z.string().nullable(),
    adjudicatedAt: z.coerce.date(),
    planId: z.string().nullable(),
});
const ComparedSideSchema = z.union([package_data_adjudication_types_1.ComparedValueSchema, package_data_adjudication_types_1.RowExistenceSchema]);
exports.ProfiledDisagreementSchema = z.object({
    sampleResultId: z.string(),
    packageId: z.string(),
    runNumber: z.number().int(),
    anchor: consensus_types_1.AnchorSchema,
    direction: package_data_adjudication_types_1.DiscrepancyDirectionSchema.nullable(),
    scoredGroundTruth: ComparedSideSchema,
    vettedGroundTruth: package_data_adjudication_types_1.AnchoredDatumSchema.nullable(),
    inferred: ComparedSideSchema,
    resolution: exports.DisagreementResolutionSchema,
    groundTruthChanged: z.boolean(),
    classification: exports.DisagreementClassificationSchema.nullable(),
    requestId: z.string().nullable(),
    planId: z.string().nullable(),
});
exports.ProfileExperimentRefSchema = z.object({
    id: z.string(),
    task: z.string(),
    description: z.string(),
    dataset: z.object({ id: z.string(), name: z.string(), version: z.number().int() }),
    scoringId: z.string().nullable(),
});
exports.ProfileTotalsSchema = z.object({
    disagreements: z.number().int(),
    errors: z.number().int(),
    notErrors: z.number().int(),
    awaitingExpert: z.number().int(),
    notDispatched: z.number().int(),
    structural: z.number().int(),
});
exports.ProfileStatusSchema = z.object({
    assessmentStatus: package_data_adjudication_types_1.ExperimentAssessmentStatusSchema,
    totals: exports.ProfileTotalsSchema,
    resolvedShare: z.number(),
    firstDispatchedAt: z.coerce.date().nullable(),
    lastAssessedAt: z.coerce.date(),
    openPlanIds: z.string().array(),
    notAssessableSampleResultIds: z.string().array(),
});
exports.ProfileCurrentClauseSchema = z.object({
    clauseId: z.string(),
    version: z.number().int(),
    description: z.string(),
});
exports.ProfileClauseEntrySchema = z.object({
    clauseId: z.string(),
    propertyKey: property_key_1.PropertyKeySchema,
    clauseNumber: z.number().int(),
    version: z.number().int(),
    shortName: z.string(),
    description: z.string(),
    status: package_data_spec_status_1.PackageDataSpecStatusSchema,
    current: exports.ProfileCurrentClauseSchema.nullable(),
    replacedByClauseId: z.string().nullable(),
});
exports.ProfileErrorCodeEntrySchema = z.object({
    errorCodeId: z.string(),
    propertyKey: property_key_1.PropertyKeySchema,
    code: z.string(),
    description: z.string(),
    status: package_data_spec_status_1.PackageDataSpecStatusSchema,
});
exports.ProfileDictionarySchema = z.object({
    clauses: exports.ProfileClauseEntrySchema.array(),
    errorCodes: exports.ProfileErrorCodeEntrySchema.array(),
});
exports.ProfileCitedClauseSchema = z.object({
    clauseId: z.string(),
    propertyKey: property_key_1.PropertyKeySchema,
    clauseNumber: z.number().int(),
    rank: z.number().int().min(1),
});
exports.ProfileOccurrenceSchema = exports.SampleRefSchema.extend({
    anchor: consensus_types_1.AnchorSchema,
    direction: package_data_adjudication_types_1.DiscrepancyDirectionSchema.nullable(),
    scoredGroundTruth: ComparedSideSchema,
    vettedGroundTruth: package_data_adjudication_types_1.AnchoredDatumSchema.nullable(),
    inferred: ComparedSideSchema,
    comment: z.string().nullable(),
    citedClauses: exports.ProfileCitedClauseSchema.array(),
});
exports.ProfileClauseBucketSchema = z.object({
    propertyKey: property_key_1.PropertyKeySchema,
    clauseNumber: z.number().int(),
    citedClauseIds: z.string().array(),
    occurrenceCount: z.number().int(),
    sampleCount: z.number().int(),
    distinctIssueCount: z.number().int(),
    occurrenceShare: z.number(),
    occurrences: exports.ProfileOccurrenceSchema.array(),
});
exports.ProfileErrorCodeBucketSchema = z.object({
    errorCodeId: z.string(),
    occurrenceCount: z.number().int(),
    sampleCount: z.number().int(),
    distinctIssueCount: z.number().int(),
    occurrenceShare: z.number(),
    occurrences: exports.ProfileOccurrenceSchema.array(),
});
exports.ProfileSampleRunSchema = z.object({
    runNumber: z.number().int(),
    sampleResultId: z.string(),
    disagreements: exports.ProfiledDisagreementSchema.array(),
});
exports.ProfileSampleSchema = z.object({
    packageId: z.string(),
    mpn: z.string(),
    packageUrl: z.string(),
    runs: exports.ProfileSampleRunSchema.array(),
});
exports.ProfileDispatchSchema = z.object({
    requestId: z.string(),
    planId: z.string().nullable(),
    packageId: z.string(),
    sliceKey: slice_key_1.SliceKeySchema,
    sliceVersion: z.number().int(),
    planStatus: z.nativeEnum(plan_status_1.PlanStatus).nullable(),
    itemCount: z.number().int(),
    createdAt: z.coerce.date(),
});
exports.ExperimentErrorProfileSchema = z.object({
    profileVersion: z.literal(exports.EXPERIMENT_ERROR_PROFILE_VERSION),
    generatedAt: z.coerce.date(),
    experiment: exports.ProfileExperimentRefSchema,
    slice: z.object({ sliceKey: slice_key_1.SliceKeySchema, sliceVersion: z.number().int() }),
    status: exports.ProfileStatusSchema,
    dictionary: exports.ProfileDictionarySchema,
    byClause: exports.ProfileClauseBucketSchema.array(),
    byErrorCode: exports.ProfileErrorCodeBucketSchema.array(),
    samples: exports.ProfileSampleSchema.array(),
    unresolved: exports.ProfiledDisagreementSchema.array(),
    groundTruthCorrections: exports.ProfiledDisagreementSchema.array(),
    dispatches: exports.ProfileDispatchSchema.array(),
});
//# sourceMappingURL=experiment-error-profile.types.js.map